import { queryOptions } from "@tanstack/react-query";
import { getSiteContext, type SiteContext, type RouteVideoRow } from "./site-context.functions";
import type { VideoConfig } from "./video-embeds";

export const siteContextQO = queryOptions({
  queryKey: ["site-context"],
  queryFn: () => getSiteContext(),
  staleTime: 60_000,
  gcTime: 5 * 60_000,
});

export function videoFromOverride(row: RouteVideoRow | undefined, fallback?: VideoConfig): VideoConfig | undefined {
  if (!row) return fallback;
  return {
    videoId: row.video_id,
    name: row.name ?? fallback?.name ?? "Watch the walkthrough",
    description: row.description ?? fallback?.description ?? "",
    uploadDate: row.upload_date ?? fallback?.uploadDate ?? new Date().toISOString(),
  };
}

export function applyTitleSuffix(title: string, suffix: string | undefined): string {
  const s = (suffix ?? "").trim();
  if (!s) return title;
  if (title.includes(s)) return title;
  return `${title} ${s}`;
}

export type { SiteContext };